import { render } from "./TicketCardControl.vue?vue&type=template&id=35285c4c"
import script from "./TicketCardControl.vue?vue&type=script&lang=js"
export * from "./TicketCardControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__